// nel theme.liquid presente lo script con defer per collegare il js (se non funziona post aggiornamento verificare)

// con questa funzione forziamo l'e-commerce ad aggiungere una riga con codice univoco ad ogni aggiunta carrello
(function(){
  function ensureSeparateLine(form){
    if (!form || !/\/cart\/add/.test(form.action)) return;
    var name = 'properties[_riga]'; // underscore = nascosta in carrello/checkout
    var hid = form.querySelector('input[name="'+name+'"]');
    if (!hid) {
      hid = document.createElement('input');
      hid.type = 'hidden';
      hid.name = name;
      form.appendChild(hid);
    }
    // token unico per ogni click
    hid.value = Date.now().toString(36) + Math.random().toString(36).slice(2,8);
  }

  // Copre submit classico e pulsanti nel form
  document.addEventListener('submit', function(e){
    if (e.target.matches('form[action*="/cart/add"]')) ensureSeparateLine(e.target);
  }, true);

  document.addEventListener('click', function(e){
    var btn = e.target.closest('form[action*="/cart/add"] [type="submit"][name="add"]');
    if (btn) ensureSeparateLine(btn.form);
  }, true);
})();

// Nasconde i pulsanti - / + e blocca la modifica della quantità (max fisso = 1) in cart page e cart drawer
(function(){

  function hideButton(btn){
    if (!btn) return;
    btn.disabled = true;
    btn.setAttribute('aria-disabled','true');
    btn.setAttribute('aria-hidden','true');
    btn.setAttribute('tabindex','-1');
    btn.style.pointerEvents = 'none';
    btn.style.display = 'none';
  }

  function lockInput(input){
    if (!input) return;
    // Forza quantità a 1 e impedisce modifiche manuali
    input.value = 1;
    input.min = 1;
    input.max = 1;
    input.step = 1;
    input.readOnly = true;              // non usiamo disabled per non perdere il submit
    input.setAttribute('aria-readonly','true');

    // blocca tentativi via tastiera/rotellina
    function clamp(){
      if (parseInt(input.value || '1',10) !== 1){
        input.value = 1;
        input.dispatchEvent(new Event('change', {bubbles:true}));
      }
    }
    input.addEventListener('input', clamp);
    input.addEventListener('change', clamp);
    input.addEventListener('keydown', function(e){
      if (["ArrowUp","PageUp","+","=","ArrowDown","PageDown","-","_"] .includes(e.key)) e.preventDefault();
    });
    input.addEventListener('wheel', function(e){ e.preventDefault(); }, {passive:false});
  }

  function processLine(line){
    // input quantità
    var input = line.querySelector('input[type="number"][name*="updates"], input[name="quantity"]');
    lockInput(input);

    // nascondi pulsanti + e - (vari temi)
    hideButton(line.querySelector('[name="plus"]'));
    hideButton(line.querySelector('[name="minus"]'));
    hideButton(line.querySelector('.quantity__button[name="plus"]'));
    hideButton(line.querySelector('.quantity__button[name="minus"]'));
    hideButton(line.querySelector('button[aria-label*="increase" i]'));
    hideButton(line.querySelector('button[aria-label*="decrease" i]'));
    line.querySelectorAll('[data-quantity-increment], [data-quantity-decrement], [data-action="increase"], [data-action="decrease"], [data-step="increment"], [data-step="decrement"]').forEach(hideButton);
  }

  function apply(){
    document.querySelectorAll('.cart-item, [data-cart-item], .cart-drawer__item, li[data-quantity]').forEach(processLine);
  }

  // inizializza e osserva cambi dinamici
  document.addEventListener('DOMContentLoaded', apply);
  document.addEventListener('cart:updated', apply);
  var mo = new MutationObserver(apply);
  mo.observe(document.documentElement, {subtree:true, childList:true});
})();